<div class="offcanvas-header d-flex align-items-center justify-content-between position-relative">
    <div class="d-flex align-items-center justify-content-start font-semibold text-primary f-16">Create Scheme</div>
    <div class="d-flex align-items-center justify-content-end border-bottom gap-2">
      <app-button
        [buttonLabel]="'New Scheme'"
        [buttonClass]="'pink_button text-nowrap'"
        [buttonId]="'save_invoice'"
        [buttonType]="'submit'"
        (buttonOutputEvent)="newCreateScheme()"
      ></app-button>
      <app-button
        [buttonLabel]="'Save'"
        [buttonId]="'saveButton'"
        [buttonClass]="'blue_button'"
        [buttonType]="'submit'"
        (buttonOutputEvent)="saveInsertUpdateShemeData()"
      >
      </app-button>
      <app-export-dropdown [requestModel]="apiRequestModel" [gridApi]="[gridApiCreateSchemeList]" [gridName]="[storageName.INVESTMENT_FUND_CREATE_SHECEM_GRID]" (callApiForExport)="callApiForExport()"></app-export-dropdown>
      <app-button class="my-0" (buttonOutputEvent)="close()" [buttonLabel]="'Close'" [buttonClass]="'light_button'" 
        [buttonType]="'button'">
      </app-button>
    </div>
</div>
<div class="card m-2">
  <form autocomplete="off" ngNativeValidate #createSchemeForm="ngForm" class="h-100 p-0">
    <div class="row m-0">
      <div class="col-12 d-flex flex-column px-0">
        <div class="row m-0 border-top-0">
            <div class="col-12 d-flex p-0">
                <div class="col-4 d-flex border-right py-2">
                    <div class="col-12">
                        <div class="col d-flex gap-1 align-items-center pb-2 border-bottom">
                            <h1 class="text-primary font-semibold f-16 mb-0 mx-3">
                                Scheme Details
                            </h1>        
                        </div>
                        <div class="col d-flex gap-1 align-items-center my-2 mx-3">
                            <div class="">
                                <label for="schemename" class="f-14 font-semibold pe-1 text-gray-color text-nowrap mb-0 w-120px">
                                    Scheme Name<span class="text-color-danger">*</span>
                                </label>
                            </div>
                            <div class="col">
                                <app-input 
                                    onlyAlphabetsAndNumbers 
                                    [inputName]="'schemeName'" 
                                    [inputType]="'text'"
                                    [inputId]="'schemeName'" 
                                    [inputPlaceholder]="''" 
                                    [inputValue]="formModel?.schemeName"
                                    (inputValueEmit)="formModel.schemeName = $event" 
                                    [isRequired]="true"
                                    (keydown.enter)="onKeydown($event, 'active')"
                                    [ngClass]="{'border-red' : !formModel?.schemeName && submit}">
                                </app-input>
                            </div>
                        </div>
                        <div class="col d-flex gap-1 align-items-center mb-2 mx-3">
                            <div class="">
                                <label for="alternateName" class="f-14 font-semibold text-gray-color text-nowrap mb-0 w-120px">
                                    Redemption on<span class="text-color-danger">*</span>
                                </label>
                            </div>
                            <div class="col">
                                <app-select 
 
                                    onlyAlphabets 
                                    [id]="'redemptionOnId'" 
                                    [name]="'redemptionOn'"
                                    [options]="getAllDropdownModel?.redemptionOnDropdown" [selectedValue]="formModel?.redemptionOnId"
                                    (valueChanged)="formModel.redemptionOnId= $event"
                                    (keydown.enter)="onKeydown($event, 'active')"
                                    [ngClass]="{'border-red' : !formModel?.redemptionOnId &&  submit}" 
                                    [isRequired]="true"
                                    [isDisabled]="formModel.canDeleteOrUpdate==false? true : false">
                                </app-select>
                            </div>
                        </div>
                        <div class="col d-flex gap-1 align-items-center mb-2 mx-3">
                            <div class="">
                                <label for="duration" class="f-14 font-semibold text-gray-color text-nowrap mb-0 w-120px">
                                    Duration<span class="text-color-danger">*</span></label>
                                </div>
                            <div class="col d-flex">
                                <div class="col">
                                    <app-input 
                                    class="custom-number-input"
                                    onlyAlphabetsAndNumbers
                                    [inputName]="'duration'" 
                                    [inputType]="'number'"
                                    [inputId]="'duration'" 
                                    [min]="1"
                                    [inputValue]="formModel?.duration"
                                    (inputValueEmit)="formModel.duration = $event" 
                                    [isRequired]="true"
                                    [readOnly]="formModel.canDeleteOrUpdate==false? true : false"
                                    (keydown.enter)="onKeydown($event, 'active')"
                                    [ngClass]="{'border-red' : !formModel?.duration &&  submit}">
                                    </app-input>
                                </div>
                            </div>
                            <div class="col-6 d-flex">
                                <div class="col">
                                    <app-select 
                                    class="col-3" 
                                    onlyAlphabets 
                                    [id]="'durationTypeId'" 
                                    [name]="'durationType'"
                                    [options]="getAllDropdownModel?.durationTypeDropdown" 
                                    [selectedValue]="formModel?.durationTypeId"
                                    (valueChanged)="formModel.durationTypeId= $event;"
                                    (keydown.enter)="onKeydown($event, 'active')"
                                    [ngClass]="{'border-red' : !formModel?.durationTypeId &&  submit}" 
                                    [isRequired]="true"
                                    [isDisabled]="formModel.canDeleteOrUpdate==false? true : false">
                                    </app-select>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex gap-1 align-items-center mb-2 mx-3">
                            <div class="">
                                <label for="category"
                                    class="f-14 font-semibold text-gray-color text-nowrap mb-0 w-120px">
                                    Installment Type<span class="text-color-danger">*</span>
                                </label>
                            </div>
                            <div class="col gap-3 d-flex">
                                <div class="col">
                                    <app-select 
                                    class="col-3" 
                                    onlyAlphabets 
                                    [id]="'installmentTypeId'" 
                                    [name]="'installmentType'"
                                    [options]="getAllDropdownModel?.installmentTypeDropdown"
                                    [selectedValue]="formModel?.installmentTypeId"
                                    (valueChanged)="formModel.installmentTypeId= $event"
                                    (keydown.enter)="onKeydown($event, 'active')"
                                    [isValueOptionShow]="false"
                                    [optionDisable]="formModel.durationTypeId=='1'? '4' :'0'"
                                    [isDisabled]="formModel.canDeleteOrUpdate==false? true : false"
                                    [ngClass]="{'border-red' : !formModel?.installmentTypeId &&  submit}" 
                                    [isRequired]="true">
                                    </app-select>
                                </div>
                            </div>
                        </div>
                        <div class="col d-flex gap-1 align-items-center mb-2 mx-3">
                            <div class="">
                            <label for="Decimal Point" class="f-14 font-semibold text-gray-color text-nowrap mb-0 w-120px">
                                Installment Amt.
                            </label>
                            </div>
                            <div class="col">
                            <app-input 
                                [decimalRestrictedDigit]="2"
                                [isBlureApplicable]="true"
                                [applyDecimalOrPercent]="true"
                                [inputClass]="'text-end'"
                                [inputName]="'installmentAmount'" 
                                [inputType]="'text'"
                                [inputId]="'installmentAmount'" 
                                [inputPlaceholder]="''" 
                                [inputValue]="formModel?.installmentAmount || 0"
                                (inputValueEmit)="formModel.installmentAmount = $event" 
                                [isRequired]="false"
                                (keydown.enter)="onKeydown($event, 'active')"
                                [readOnly]="formModel.canDeleteOrUpdate==false? true : false">
                            </app-input>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col py-2 px-3 d-flex flex-column">
                    <div class="col-12 p-0 creditScheme position-relative">
                        <app-ag-grid 
                        id="taskEvents" 
                        class="all_aggrid_tables" 
                        [dataModel]="agGridDataModelCreateScheme"
                        [rowData]="getAllgetAllcreateschemerowData" 
                        (gridReady)="onGridReady($event)"
                        (onTextCellClick) = "handleTextClick($event)"
                        (onPagination)="onPagination($event)" 
                        [columnSettings]="true" 
                        [gridOptions]="gridOptionsCreateScheme"
                        [rowHeight]="27"
                        (onDeleteIconClick)="onDeleteIconClick($event)"
                        (onSortIconClick)="onSortIconClick($event)"
                        >
                        </app-ag-grid>
                    </div> 
                </div>
           </div>
        </div>
      </div>
    </div>
  </form>
</div>
